import styles from './unservereinpage.module.css';
import { getLink } from '../../../../config/sideMenuData';
import { useNavigate } from "react-router-dom";
function UnserVereinPage() {
    const navigate = useNavigate();
    return (
        <section className={styles.content}>
            <h1>Unser Verein</h1>
            <div className={styles.items}>
                <div className={styles.itemImgLeft} onClick={() => navigate(getLink('TuS-Organisation'))}>
                    <img
                        src={`/images/unser_verein/organisation_klein.png`}
                        alt='Organisation: Teamwork'
                    />
                    <section className={styles.text}>
                        <h2>TuS-Organisation</h2>
                        <div>
                            <p>Hier findet ihr alles über die Verwaltung des TuS. Von Geschäftsstelle, über Vorstand und Beirat sowie Jugendschutz Öffentlichkeitsarbeit und Leitbild.</p>
                        </div>
                    </section>
                </div>
                <div className={styles.itemImgRight} onClick={() => navigate(getLink('Sportstätten'))}>
                    <section className={styles.text}>
                        <h2>TuS-Sportstätten</h2>
                        <div>
                            <p>Hier findet ihr alle unserer Sportstätten. Von unseren Sportplätzen und Sporthallen sowie unserer Beach-Arena. Deren Anfahrtsmöglichkeiten, Austattungen sowie Verboten.</p>
                        </div>
                    </section>
                    <img
                        src={`/images/unser_verein/sportstaetten/sportplatz_oben.webp`}
                        alt='Sportplatz: Basaltarena'
                    />
                </div>
                <div className={styles.itemImgLeft} onClick={() => window.location.href = getLink('Sportlerbar')}>
                    <img
                        src={`/images/unser_verein/logo_sportlerbar.png`}
                        alt='Sportlerbar-Logo'
                    />
                    <section className={styles.text}>
                        <h2>Sportlerbar</h2>
                        <div>
                            <p>Hier kann die dritte Halbzeit begonnen werden. Unsere stetige Begleitung in Sachen Verpflegung. </p>
                        </div>
                    </section>
                </div>
                <div className={styles.itemImgRight} onClick={() => navigate(getLink('Nachhaltigkeit beim TuS'))}>

                    <section className={styles.text}>
                        <h2>Nachhaltigkeit beim TuS</h2>
                        <div>
                            <p>Auch für uns ist dies ein wichtiges Thema, welches wir gerne angehen. Es ist ein stetiger Prozess bei dem weiter Ideen sowie helfende Händer gerne gesehen sind.</p>
                        </div>
                    </section>
                    <img
                        src={`/images/unser_verein/nachhaltigkeit.png`}
                        alt='Nachhaltigkeitsbild: Welt mit Recycling-Symbol'
                    />
                </div>
                <div className={styles.itemImgLeft} onClick={() => navigate(getLink('Ihr Engagement beim TuS 05'))}>
                    <img
                        src={`/images/unser_verein/engagement_klein.png`}
                        alt='Engagementbild: Laufschuhe, Person, Hantel'
                    />
                    <section className={styles.text}>
                        <h2>Engagement beim TuS</h2>
                        <div>
                            <p>Ihr möchtet den TuS unterstützen. Hierzu bieten wir drei verschiedene Möglichkeiten: gesellschaftliches, soziales und gesundheitliches Engagement. Wir freuen uns wirklich sehr über jeder Form der Unterstützung.</p>
                        </div>
                    </section>
                </div>
                <div className={styles.itemImgRight} onClick={() => window.open(getLink('Historie'), '_blank')}>
                    <section className={styles.text}>
                        <h2>Historie</h2>
                        <div>
                            <p>Eine chronische, virtuelle Übersicht zu der Historie des TuS. Alle wichtigen geschichtlichen Hintergrundinformationen von der Gründung bishin zur heutigen Zeit könnt ihr hier finden.</p>
                        </div>
                    </section>
                    <img
                        src={`/images/unser_verein/virtuelles_heimatmuseum.png`}
                        alt='Website: Virtuelles Heimatmuseum'
                    />
                </div>
            </div>
        </section>
    );
};

export default UnserVereinPage;